import React from 'react'

export const LoadingApi = () => {
  return (
   

    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>

   
  )
}
